import { Heading, Box, Text } from '@medely/ui-kit';
import { Link } from '@medely/web-components';
import { config } from '@mp/config';
import { useCurrentUser } from '../../hooks/useCurrentUser';

import React from 'react';

export const CancelationPolicy = () => {
  const { isAgency } = useCurrentUser();
  const link = isAgency
    ? config.help.cancellationsAndNoShowAgency
    : config.help.cancellationsAndNoShow;
  return (
    <Box>
      <Heading size="s" color="text.primary" testId="cancelation-policy-title">
        Cancellation policy
      </Heading>
      <Box my={1}>
        <Text size="m" testId="cancelation-policy-text">
          You can cancel a shift without penalty within 30 minutes of booking or at least 24 hours
          before it starts.{' '}
          <Link href={link} external>
            Learn more
          </Link>
        </Text>
      </Box>
    </Box>
  );
};
